import { ShareRoute } from '@/system-modules/share/v1/api/ShareRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'

export class RemoveViewerRoute extends ShareRoute<null, null> {
  constructor(private readonly viewerUuid: string) {
    super()
  }

  type(): EnumRouteType {
    return EnumRouteType.DELETE
  }

  url(): string {
    return '/api/system/v1/share/viewers/' + this.viewerUuid
  }

  offline(): Promise<ApiResponse<null>> {
    return Promise.resolve(new ApiResponse({ success: true, data: null }))
  }
}
